import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbProps,
  Icon,
} from "@chakra-ui/react"
import NextLink from "next/link"
import { MdChevronRight } from "react-icons/md"
import { RiHomeHeartFill } from "react-icons/ri"

export type CategoryProps = {
  name: string
  termCode: string
}

type BreadcrumbsProps = BreadcrumbProps & {
  category: CategoryProps[]
  showFirst?: boolean
  catPage?: boolean
}

const Breadcrumbs = ({ category, showFirst, catPage }: BreadcrumbsProps) => {
  return (
    <Box>
      {category
        .filter((cat) => cat.termCode === "BISAC")
        .slice(0, showFirst ? 1 : undefined)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((cat, i) => {
          const catNames = cat.name.split(" | ")
          const breadCrumbLinks: string[] = []
          catNames.map((catName) =>
            breadCrumbLinks.push(`${encodeURIComponent(catName)}`)
          )

          return (
            <Breadcrumb
              key={i}
              fontSize={showFirst ? "xs" : "sm"}
              separator={<MdChevronRight color={"gray.500"} />}
              spacing={0}
              mb={4}
              listProps={{
                flexWrap: "wrap",
              }}
            >
              {showFirst && (
                <BreadcrumbItem>
                  <BreadcrumbLink
                    as={NextLink}
                    href={"/"}
                    _hover={{
                      textDecoration: "none",
                    }}
                    p={1.5}
                    title={"Home"}
                  >
                    <Icon
                      as={RiHomeHeartFill}
                      h={4}
                      w={4}
                      mt={1}
                    />
                  </BreadcrumbLink>
                </BreadcrumbItem>
              )}
              {catNames.map((catName, i, catNames) => {
                const isCurrentPage = catPage
                  ? i === catNames.length - 1
                  : false
                return (
                  <BreadcrumbItem
                    key={i}
                    isCurrentPage={isCurrentPage}
                  >
                    <BreadcrumbLink
                      href={`/c/${breadCrumbLinks.slice(0, i + 1).join("/")}`}
                      color={(!isCurrentPage && "blue.600") || undefined}
                      title={catName}
                      textDecoration={
                        (!isCurrentPage && "underline") || undefined
                      }
                      textDecorationStyle={"dashed"}
                      textUnderlineOffset={"0.3em"}
                      minW={"max-content"}
                      _hover={{
                        textDecoration: "none",
                      }}
                      p={1.5}
                    >
                      {catName}
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                )
              })}
            </Breadcrumb>
          )
        })}
    </Box>
  )
}

export default Breadcrumbs
